import type { Palette } from './types';

export const PALETTES: Record<string, Palette> = {
  matrix: {
    name: 'matrix',
    primary: '#00ff41',
    bright: '#00ff00',
    dim: '#005500',
    accent: '#00ffff',
    border: '#00ff00',
    borderDim: '#006600',
    negative: '#aa4444',
    negativeBorder: '#664444',
    rainHead: '#ffffff',
    rainBright: '#00ff00',
    rainMid: '#00aa00',
    rainDim: '#005500',
  },
  cyberpunk: {
    name: 'cyberpunk',
    primary: '#ff44ff',
    bright: '#ff00ff',
    dim: '#550055',
    accent: '#00ffff',
    border: '#ff00ff',
    borderDim: '#660066',
    negative: '#aa8844',
    negativeBorder: '#665533',
    rainHead: '#ffffff',
    rainBright: '#ff00ff',
    rainMid: '#aa00aa',
    rainDim: '#550055',
  },
  amber: {
    name: 'amber',
    primary: '#ffaa00',
    bright: '#ffcc44',
    dim: '#666600',
    accent: '#ff6600',
    border: '#ffaa00',
    borderDim: '#664400',
    negative: '#6666aa',
    negativeBorder: '#444466',
    rainHead: '#ffffff',
    rainBright: '#ffcc44',
    rainMid: '#aa7700',
    rainDim: '#553300',
  },
  ocean: {
    name: 'ocean',
    primary: '#00aaff',
    bright: '#44ccff',
    dim: '#003366',
    accent: '#00ffff',
    border: '#44aaff',
    borderDim: '#004466',
    negative: '#aa6644',
    negativeBorder: '#664433',
    rainHead: '#ffffff',
    rainBright: '#44ccff',
    rainMid: '#0066aa',
    rainDim: '#003355',
  },
  void: {
    name: 'void',
    primary: '#aa66ff',
    bright: '#cc88ff',
    dim: '#332255',
    accent: '#ffffff',
    border: '#aa66ff',
    borderDim: '#442266',
    negative: '#66aa44',
    negativeBorder: '#446633',
    rainHead: '#ffffff',
    rainBright: '#cc88ff',
    rainMid: '#7744aa',
    rainDim: '#332255',
  },
  ember: {
    name: 'ember',
    primary: '#ff4422',
    bright: '#ff6644',
    dim: '#551100',
    accent: '#ffaa00',
    border: '#ff4422',
    borderDim: '#661100',
    negative: '#4488aa',
    negativeBorder: '#334466',
    rainHead: '#ffffff',
    rainBright: '#ff6644',
    rainMid: '#aa2200',
    rainDim: '#551100',
  },
  frost: {
    name: 'frost',
    primary: '#88ccff',
    bright: '#bbddff',
    dim: '#224455',
    accent: '#ffffff',
    border: '#88ccff',
    borderDim: '#335566',
    negative: '#cc8866',
    negativeBorder: '#665544',
    rainHead: '#ffffff',
    rainBright: '#bbddff',
    rainMid: '#5588aa',
    rainDim: '#224455',
  },
  biomech: {
    name: 'biomech',
    primary: '#aaff00',
    bright: '#ccff44',
    dim: '#334400',
    accent: '#00ffaa',
    border: '#aaff00',
    borderDim: '#446600',
    negative: '#aa4488',
    negativeBorder: '#663355',
    rainHead: '#ffffff',
    rainBright: '#ccff44',
    rainMid: '#66aa00',
    rainDim: '#334400',
  },
};

export const TEMPLATE_PALETTES: Record<string, string> = {
  material_study: 'amber',
  textural_macro: 'amber',
  environmental: 'ocean',
  atmospheric_depth: 'ocean',
  process_state: 'ember',
  material_collision: 'ember',
  specimen: 'frost',
  minimal_object: 'frost',
  abstract_field: 'void',
  temporal_diptych: 'void',
  liminal: 'cyberpunk',
  ruin_state: 'cyberpunk',
  essence: 'biomech',
  site_decay: 'matrix',
};

const DEFAULT_PALETTE = 'matrix';

export function paletteForTemplate(templateId: string): Palette {
  const name = TEMPLATE_PALETTES[templateId] ?? DEFAULT_PALETTE;
  return PALETTES[name] ?? PALETTES[DEFAULT_PALETTE];
}
